import { render, staticRenderFns } from "./Match3Game.vue?vue&type=template&id=1bea948f&scoped=true"
import script from "./Match3Game.vue?vue&type=script&lang=js"
export * from "./Match3Game.vue?vue&type=script&lang=js"
import style0 from "./Match3Game.vue?vue&type=style&index=0&id=1bea948f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea948f",
  null
  
)

export default component.exports